import { desc } from './desc'

export const getSorting = (order, orderBy) =>
  (order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy))
